import {
  AttributeOptions,
  IngressRequestForm,
  MultiSelectOption,
} from '@dispatch/shared/types';
import { SelectField } from '@dispatch/web/ui';
import { Grid } from '@mui/material';
import {
  Control,
  FieldValues,
  UseFieldArrayAppend,
  UseFormWatch,
} from 'react-hook-form';
import {
  buildClaimAttributeRow,
  getAddableAttributeOptions,
} from '../pinnedClaimAttributes';

export type IngressClaimAttributesAddProps = {
  append: UseFieldArrayAppend<FieldValues, 'claimAttributes'>;
  control: Control<FieldValues>;
  watch: UseFormWatch<IngressRequestForm>;
  companyAttributes: AttributeOptions[];
  /** Excluded from the options; nothing renders while undefined (resolving). */
  pinnedAttributeGuids: readonly string[] | undefined;
  isReview?: boolean;
};

export function IngressClaimAttributesAdd({
  append,
  control,
  watch,
  companyAttributes,
  pinnedAttributeGuids,
  isReview,
}: IngressClaimAttributesAddProps) {
  const handleAddClaimAttributes = (
    value: MultiSelectOption | (string | number)[] | null
  ) => {
    if (!value || Array.isArray(value)) return;

    const selectedAttribute = companyAttributes.find(
      (attribute) => attribute.value === value.value
    );

    append(buildClaimAttributeRow(selectedAttribute));
  };

  if (!pinnedAttributeGuids) {
    return null;
  }

  return (
    <div
      style={{
        padding: '24px',
      }}
    >
      <Grid container rowSpacing={4} spacing={2}>
        <Grid item xs={6}>
          <SelectField
            id="addSelectedAttributeGUID"
            name="addSelectedAttributeGUID"
            label="Add New Attribute"
            control={control}
            onValueChange={handleAddClaimAttributes}
            options={getAddableAttributeOptions(
              companyAttributes,
              watch('claimAttributes'),
              pinnedAttributeGuids
            )}
            disabled={isReview}
          />
        </Grid>
      </Grid>
    </div>
  );
}
